import useApi, { ApiOptions } from '../base/useApi';
import ConsultantDTO from '@src/adapters/dto/consultant/ConsultantDTO';

interface Params {
  pageSize: number;
  currentPage: number;
}

interface Result {
  consultants: ConsultantDTO[];
  recordCount: number;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/consultant/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindConsultants = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useFindConsultantsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindConsultants;
